module.exports = __webpack_public_path__ + "img/img-6.59e66d68.png";